import React from 'react'
// libs
import { FieldArray } from 'redux-form'
// view components
import MappedProperty from './components/MappedProperty'
// context
import { RiskTemplateAPIContext } from 'containers/Risks/RiskTemplate/Edit/layers/API'
// constants
import { FROM_PARENT_FIELD, SELECT_GROUP_LABELS } from 'constants/index'
// types
import { FieldType } from 'types/graphql'
// views
import { Title } from './views'

interface Props {
  name: string
  fields: any[]
  dueDateNowOnly?: boolean
}

const MappedProperties: React.FC<Props> = ({ name, fields, dueDateNowOnly }) => {
  const { basicFields = [] } = React.useContext(RiskTemplateAPIContext)

  const mainFormFields = basicFields
    .filter((field) => field.fieldType === FieldType.Lookup)
    .map((field) => ({
      label: field.label,
      value: FROM_PARENT_FIELD,
      sourceFieldId: field.id
    }))

  const prepareLookupOptions = (options) =>
    options.map((item) => {
      if (item.label === SELECT_GROUP_LABELS.FIELDS) {
        return { ...item, options: [...mainFormFields, ...item.options] }
      }
      return item
    })

  return (
    <>
      <Title>Mapped properties</Title>
      <FieldArray<any>
        name={name}
        templateFields={fields}
        dueDateNowOnly={dueDateNowOnly}
        component={MappedProperty as any}
        lookupProps={{ prepareOptions: prepareLookupOptions }}
      />
    </>
  )
}

export default MappedProperties
